import { FC } from 'react'
import { CircularProgress, IconButton, Tooltip } from '@mui/material'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { useStore } from 'effector-react'
import {
  $markingUnreadPaidServiceId,
  markPaidServiceAsUnreadFx
} from '../../../Api/PaidService/inWork'

type UnreadPaidServiceBtnProps = {
  paidServiceId: number
}

export const UnreadPaidServiceBtn: FC<UnreadPaidServiceBtnProps> = ({
  paidServiceId
}) => {
  const markingId = useStore($markingUnreadPaidServiceId)
  const isLoading = markingId === paidServiceId

  const handleClick = () => {
    if (isLoading) {
      return
    }

    markPaidServiceAsUnreadFx({ paidServiceId })
  }

  return (
    <Tooltip title="Сделать непрочитанной">
      <IconButton
        className="paid-service-mark-unread-button"
        size="small"
        onClick={handleClick}
        disabled={isLoading}
        sx={{
          p: 0,
          opacity: 0,
          visibility: 'hidden',
          transition: 'opacity 0.2s ease, visibility 0.2s ease'
        }}
      >
        {isLoading ? (
          <CircularProgress size={18} color="primary" />
        ) : (
          <FiberManualRecordIcon
            color="primary"
            sx={{ fontSize: '18px' }}
          />
        )}
      </IconButton>
    </Tooltip>
  )
}
